<template>
    <div class="mb-20">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/my' }">个人主页</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
    export default {
        name: "Crumbs",
        props:['title'],
        methods:{}
    }
</script>

<style scoped>

</style>